import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, InputGroup, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import RegBreadcrumb from '../components/RegBreadcrumb';
import { authService } from '../functions/authenticate';

import '../scss/Register.scss';

const Register = ({ runner, setRunner, setUserID, setUserName, login, setLogin, authToken, setAuthToken, marathonDetails }) => {

    const navigate = useNavigate();

    // useEffect(() => {
    //     navigate('/Login');
    // });

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if(token==='' || token===null)
        {
            navigate('/Login');
        }
        else
        {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if(!response.status)
                    {
                        navigate('/Login');
                    }
                    else if(!login)
                    {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);
                        
                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }
    }, [authToken]);
    

    const handleClick1 = () => {
        if(runner > 1)
        {
            var newRunner = runner - 1;
            setRunner(newRunner);
        }
        else
        {

        }
    }
    const handleClick2 = () => {
        var newRunner = runner + 1;
        setRunner(newRunner);
    }
    const handleChange1 = (e) => {
        e.preventDefault();
        var newRunner = e.target.value;
        console.log(Number.isInteger(newRunner));

        if(newRunner>0)
        {
            setRunner(parseInt(newRunner));
        }
    }
    const handleBtnClick1 = (e) => {
        e.preventDefault();
        localStorage.removeItem('runnerList');
        localStorage.removeItem('selectedList');
        localStorage.removeItem('promoCode');
        localStorage.removeItem('paymentID');
        localStorage.removeItem('refID');
        localStorage.removeItem('RemakePayment');
        localStorage.setItem("runnerCount", runner);
        navigate('/Register/2');
    }


    return (
        <Container fluid="lg" className='wrapper'>
            
            <h1 className="title">Marathon Registration</h1>

            <RegBreadcrumb page={0} />
            <br />

            <Row className="regForm">
                <Col md={9} xs={12}>
                    
                    <h2 className="sub-title">How many person will join the run?</h2>

                    <div className="well mb-5">

                        <Row className="mb-3">
                            <h3 className="subsub-title">Number of Runners</h3>
                            <div className='d-flex col-md-6 col-xs-12'>
                                <InputGroup >
                                    <Button
                                        variant="outline-secondary"
                                        id="button-addon1"
                                        className="btn-left"
                                        onClick={handleClick1}>
                                        &#45;
                                    </Button>
                                    <Form.Control
                                        aria-label=""
                                        aria-describedby="basic-addon2"
                                        value={runner}
                                        onChange={handleChange1}
                                        type="number"
                                        // disabled
                                    />
                                    <Button
                                        variant="outline-secondary"
                                        id="button-addon2"
                                        className="btn-right"
                                        onClick={handleClick2}>
                                        &#43;
                                    </Button>
                                </InputGroup>
                            </div>
                            <div className='d-flex col-md-6 col-xs-12 mt-2 '>
                                <button id="next-btn" className="btn btn-danger next" onClick={handleBtnClick1} >NEXT <FontAwesomeIcon icon={faChevronRight} /></button>
                            </div>
                            <p className='input-desc'>Please adjust the number of runners before proceed to insert the runners information.</p>

                            {/* <hr />
                            <div className='d-flex col-md-6 col-xs-12 mb-5'>
                                <h3 className="subsub-title">Group Code</h3>
                                <p>If you have a group code, enter it in the field below to redeem and proceed to the</p>
                            </div> */}
                        </Row>
                        
                    </div>

                    <Row className="mb-3">
                        <h2 className="sub-title">Registration Fees</h2>
                        
                        <div className="table">
                            <Table striped bordered hover id="marathon-price">
                                
                                <thead>
                                    <tr>
                                        <th width="25%">Category</th>
                                        <th width="55%">Age</th>
                                        <th width="20%">Fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        marathonDetails.map((marathon, index) => (
                                            <tr data-index={index} key={index}>
                                                <td className='desc'>{marathon.type}</td>
                                                <td className='desc'>{marathon.desc}</td>
                                                <td className='total-price'>RM {marathon.price}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </div>

                    </Row>

                </Col>

                <Col md={3} xs={12} id="run-info">
                    <h1>IMPORTANT DATES</h1>

                    <hr />

                    <h3 className='info-title'>REGISTRATION CLOSING</h3>
                    {/* <h3>25<sup>th</sup> October 2023</h3> */}
                    {/* <h6>(12 midnight)</h6> */}
                    <h3>To be announced</h3>

                    <hr />

                    <h3 className='info-title'>RACE PACK COLLECTION</h3>
                    {/* <h3>24<sup>th</sup> - 25<sup>th</sup> October 2024</h3>
                    <h6>(10:00am - 7pm)</h6>
                    <h3>26<sup>th</sup> October 2024</h3>
                    <h6>(10:00am - 5pm)</h6> */}
                    <h3>To be announced</h3>
                    <hr />

                    <h3 className='info-title'>EVENT DAY</h3>
                    <h3>27<sup>th</sup> October 2024</h3>
                    {/* <h6>(1:00am)</h6> */}

                </Col>

            </Row>

        </Container>
    );
}

export default Register;